import { createFileRoute } from '@tanstack/react-router'
import { ViewExamPage } from '_/features/pets/ui/pages/view-exam-page'

const ViewExamRoute = () => {
	const { petId, examId } = Route.useParams()
	return <ViewExamPage petId={petId} examId={examId} />
}

export const Route = createFileRoute('/_authenticated/pets/$petId/exams/$examId/')({
	staticData: { title: 'exams_title' },
	component: ViewExamRoute,
})
